
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardCardFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardCardDoc"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"launch_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effective_date_b"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effective_date_e"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"special_day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"csp_channel_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"csp_target_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"by_method_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"re_channel_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"re_target_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exclude_list_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precondition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data_source_urls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"need_registration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"identity_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"free_parking_hrs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"free_parking_times"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"basic_r"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"re_upper_bound"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"essential_money"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"essential_day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"include_card_sets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card_group_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issuer_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card_level_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"exclude_card_sets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card_group_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issuer_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card_level_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"essential_day_unit_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"re_upper_bound_unit_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_target"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":677}};
    doc.loc.source = {"body":"fragment RewardCardFull on RewardCardDoc {\n  _id\n  ticket_id\n  launch_date\n  effective_date_b\n  effective_date_e\n  special_day\n  csp_channel_ids\n  csp_target_ids\n  by_method_ids\n  re_channel_ids\n  re_target_ids\n  exclude_list_ids\n  detail\n  precondition\n  data_source_urls\n  need_registration\n  uploader\n  identity_ids\n  type_id\n  free_parking_hrs\n  free_parking_times\n  basic_r\n  re_upper_bound\n  essential_money\n  essential_day\n  currency\n  include_card_sets {\n    card_group_id\n    issuer_id\n    card_level_id\n  }\n  exclude_card_sets {\n    card_group_id\n    issuer_id\n    card_level_id\n  }\n  essential_day_unit_id\n  re_upper_bound_unit_id\n  matched_state\n  matched_target\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RewardCardFull"] = oneQuery(doc, "RewardCardFull");
        
